import classNames from 'classnames';
import React from 'react';
import { useDispatch } from 'react-redux';
import { HasClassName } from "../../component-utils";
import { useSelector } from '../../hook-utils';
import { actions } from '../../store';
import { selectMyAccess, selectMyself, selectMyData } from '../../store/reducers/config';
import { ContactsButton, TeamsQueuePresence, VoiceMailButton, QueuesButton, CallsButton } from '../MainToolbar';
import '../MainToolbar.scss';
import PresenceButton from '../PresenceButton';
import './MainToolbar.scss';


interface Props extends HasClassName {
}

export default function MobileToolbar({ className }: Props) {
  const dispatch = useDispatch()
  const access = useSelector(selectMyAccess)
  const myId = useSelector(selectMyself)
  const me = useSelector(selectMyData)
  //const extension = useSelector(s => myId && selectExtension(s, myId))

  if (!myId || !me) return null

  return <div className={classNames('MainToolbar', className, 'MobileMainToolbar')}>
    {!access.isTeamsPbx && access.features.extensionMyLocation && <PresenceButton text={false} onMore={() => dispatch(actions.openSetPresence(myId))} />}
    {access.features.toolbarQueues && <QueuesButton />}
    {(access.features.toolbarDirectory || (access.features.companyContactsAccess || access.features.directoryCompanyContactAdd || access.features.directoryPersonalContactAdd)) && <ContactsButton />}
    {(access.features.toolBarVoicemail || me.canReceiveVoicemail) && <VoiceMailButton dropdown={false} />}
    {access.features.toolbarCallHistory && <CallsButton />}
    {access.isTeamsPbx && <TeamsQueuePresence />}
  </div>
}

